import {useRecoilState} from 'recoil';
import {informationAtom} from '../store/InformationStore';
import {useLocation} from 'react-router-dom';

export const isSimulation = () => {
    const location = useLocation();
    return () => {
        return location.pathname === "/simulation";
    }
}

export const setSimulationNumber = () => {
    const [information, setInformation] = useRecoilState(informationAtom);

    const set = (number, step) => {
        setInformation(prev => ({
            ...prev,
            simulationNumber: number,
            simulationStep: step
        }));
    }

    const check = (number, step) => {
        let simulation = information.simulationNumber;
        let simulationStep = information.simulationStep;
        if (simulationStep !== step) {
            if (simulation === 12 || simulation === 7) return true;
            else return false;
        }
        return true;
    }

    return (number, step) => {
        let simulation = information.simulationNumber;
        let simulationStep = information.simulationStep;

        if (!check(number, step)) return;

        if (simulationStep === step) {
            if (simulation + 1 === number) {
                set(number, step);
            }
        } else {
            set(1, step);
        }
    };
};
